var React = require('react');

function X2 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"X2"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("g",{"style":{"mixBlendMode":"multiply"},"key":0},React.createElement("polygon",{"points":"46.46 27.5 25.56 2.55 0 4.68 30.59 43.99 46.46 27.5","fill":"#e5c83d"})),React.createElement("polygon",{"points":"85.4 80.74 55.66 39.72 79.51 0 54.8 1.18 5.26 83.67 29.97 82.49 44.05 59.05 60.69 81.92 85.4 80.74","fill":"#f47643","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

X2.defaultProps = {"viewBox":"0 0 85.4 83.67"};

module.exports = X2;

X2.default = X2;
